import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Conditionally disables HTML elements depending on a user's entitlements.
 *
 * @example
 * <button [appHasClickEntitlement]="'app.page.delete_button.view'">Edit Query</button>
 */
@Directive({
  selector: '[appHasClickEntitlement]',
  standalone: true,
})
export class HasClickEntitlementDirective {
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private authService: AuthService,
  ) {}

  @Input() set hasClickEntitlement(entitlement: string[]) {
    const entitlements = this.authService.entitlements;

    if (!entitlements.includes(entitlement)) {
      // Disable the button if entitlement is not present
      this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', '');
    }
  }
}
